(function() {
  function $(id){ return document.getElementById(id); }
  function fmt(n, type='currency'){
    if (type === 'currency') return n.toLocaleString(undefined, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
    if (type === 'percent')  return n.toLocaleString(undefined, { maximumFractionDigits: 0 }) + '%';
    return n.toLocaleString();
  }

  function initCalc(root){
    // Avoid double-binding in theme editor reloads
    var form = root.querySelector('#roiForm');
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    form.addEventListener('submit', function(e){
      e.preventDefault();

      var rotaryCost   = parseFloat($('rotary').value);
      var costPrice    = parseFloat($('costPrice').value);
      var sellPrice    = parseFloat($('sellPrice').value);
      var shipping     = parseFloat($('shipping').value);
      var hourlySalary = parseFloat($('hourlySalary').value);
      var quantity     = parseFloat($('quantity').value);
      var tumblerTime  = parseFloat($('tumblerTime').value);

      var designTypeEls = document.getElementsByName('designType');
      var setupTime = 0;
      for (var i = 0; i < designTypeEls.length; i++) {
        if (designTypeEls[i].checked) { setupTime = parseFloat(designTypeEls[i].value); break; }
      }

      if ([rotaryCost,costPrice,sellPrice,shipping,hourlySalary,quantity,tumblerTime,setupTime].some(isNaN)) {
        alert('Please fill in all fields correctly.'); return;
      }

      var totalLaborMinutes = (tumblerTime * quantity) + setupTime;
      var totalLaborCost = (totalLaborMinutes / 60) * hourlySalary;

      var productProfit = ((sellPrice - costPrice) * quantity) - shipping;

      var monthlyProfit = productProfit - totalLaborCost;
      var monthlyROI = (monthlyProfit / rotaryCost) * 100;

      var annualProfit = monthlyProfit * 12;
      var annualROI = (annualProfit / rotaryCost) * 100;

      var weeksUntilPaid = (monthlyProfit > 0) ? ((rotaryCost / monthlyProfit) * 4.33) : NaN;

      var profitPerTumbler = (sellPrice - costPrice) - ((tumblerTime/60) * hourlySalary);
      var fixedCosts = shipping + ((setupTime/60) * hourlySalary);
      var disneyTarget = 20000;
      var tumblersForDisney = (profitPerTumbler > 0) ? Math.ceil((disneyTarget + fixedCosts) / profitPerTumbler) : NaN;

      var resultDiv = $('resultDisplay');
      resultDiv.style.display = 'block';
      resultDiv.innerHTML =
        "Congrats, you've made <strong>" + fmt(monthlyProfit) + "</strong> this month (" + 
        "<strong>" + fmt(annualProfit) + "</strong> annually) with your PiBurn!<br>" +
        "Monthly ROI: <strong>" + fmt(Math.max(0, monthlyROI), 'percent') + "</strong>, " +
        "Annual ROI: <strong>" + fmt(Math.max(0, annualROI), 'percent') + "</strong>.<br>" +
        "Weeks to pay off the rotary: <strong>" + (isNaN(weeksUntilPaid) ? 'N/A' : weeksUntilPaid.toFixed(1)) + "</strong>.<br>" +
        "Tumblers to sell for a $"+ disneyTarget.toLocaleString() +" Disney trip: <strong>" + (isNaN(tumblersForDisney) ? 'N/A' : tumblersForDisney) + "</strong>.";

      var statsGrid = $('statsGrid');
      if (statsGrid) {
        statsGrid.style.display = 'grid';
        $('statMonthlyProfit').textContent = fmt(monthlyProfit);
        $('statAnnualProfit').textContent  = fmt(annualProfit);
        $('statMonthlyROI').textContent    = fmt(Math.max(0, monthlyROI), 'percent');
        $('statWeeks').textContent         = isNaN(weeksUntilPaid) ? 'N/A' : weeksUntilPaid.toFixed(1);
      }

      if (typeof confetti === 'function') {
        confetti({ particleCount: 180, spread: 120, origin: { y: 0.6 } });
      }
    });
  }

  // Init on normal page load
  document.addEventListener('DOMContentLoaded', function(){
    var root = document.querySelector('.ld-roi');
    if (root) initCalc(root);
  });

  // Re-init in Theme Editor when section is (re)loaded
  document.addEventListener('shopify:section:load', function(evt){
    var root = evt.target.querySelector('.ld-roi');
    if (root) initCalc(root);
  });
})();
